/*
 * @Author: your name
 * @Date: 2021-01-19 12:14:20
 * @LastEditTime: 2022-02-11 14:30:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lavrock-official-platform\src\router\home.route.js
 */
const Index = () => import('../pages/index')
const PackageEdit = () => import('../pages/Package/PackageEdit')
const RenewalEdit = () => import('../pages/Package/RenewalEdit')
// const ShoppingCart = () => import('../pages/Package/ShoppingCart.vue')
const Login = () => import('../pages/Login')
const Operation = () => import('../pages/Operation')
const SingleConsole = () => import('../pages/siteAdmin/Console/index')
const TransferPage = () => import('../pages/siteAdmin/Console/TransferPage')
const ExperiencePage = () => import('../pages/siteAdmin/site-component/WebSiteContainer.vue')

export default [
	{
		path: '/',
		name: 'index',
		redirect: {
			name: 'pageList'
		},
		component: Index,
		children: [
			{
				name: 'pageList',
				path: '/pageList',
				component: () => import('@/pages/TemplateList/AIindex.vue')
			},
			{
				name: 'pageListOld',
				path: '/pageListOld',
				component: () => import('@/pages/TemplateList/index.vue')
			},
			{
				name: 'leaflet',
				path: '/leaflet/:tblType/:projId/:webType', //webType: 0-整站，1-落地页
				component: () => import('@/pages/Leaflet')
			},
			{
				name: 'packageEdit',
				path: '/packageEdit/:suitLevel',
				component: PackageEdit,
				meta: {
					requiresAuth: true
				}
			},
			{
				name: 'renewalEdit',
				path: '/renewalEdit',
				component: RenewalEdit,
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/pagePreview/:pageId&:webType&:tblName&:projType&:prodType&:webWidth&:experience&:replaceId&:isNewSuit&:suitName', // this.$router.parmas.pageId
		name: 'pagePreview',
		component: () => import('@/pages/Preview')
	},
	{
		path: '/unauthOperate',
		name: 'unauthOperate',
		component: () => import('../pages/UnauthOperate')
	},
	{
		path: '/login',
		name: 'login',
		component: Login
	},
	{
		path: '/operation',
		name: 'operation',
		component: Operation
	},
	{
		path: '/singleConsole',
		name: 'singleConsole',
		component: SingleConsole
	},
	{
		path: '/transferPage',
		name: 'transferPage',
		component: TransferPage
	},
	{
		path: '/experience',
		name: 'experience',
		component: ExperiencePage
	},

]
